<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('stepReleased', $event)" />
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            v-model="titulo"
            id="nome-simulacao"
            class="my-0"
            label="Título"
            outlined
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="6">
        <validation-provider v-slot="{ errors }" rules="required" id="possui-obra-simulacao">
          <v-select
            v-model="possuiObra"
            label="Possui Obra?"
            no-gutters
            outlined
            :items="obraMaterialList"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col cols="6">
        <validation-provider v-slot="{ errors }" rules="required" id="possui-material-simulacao">
          <v-select
            v-model="possuiMaterial"
            label="Possui Material?"
            no-gutters
            outlined
            :items="obraMaterialList"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="6">
        <validation-provider v-slot="{ errors }" rules="required" id="deprecia-no-proprio-mes">
          <v-select
            v-model="depreciaMes"
            label="Deprecia no Próprio Mês?"
            no-gutters
            outlined
            :items="obraMaterialList"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>  
      <v-col cols="6">
        <v-text-field
          v-model="almoxarifado"
          label="Almoxarifado em Operação (R$)" 
          outlined 
          type="number"
          min="0"
          step="0.01"
        />
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12" class="pt-0" id="database-ais-simulacao">
        <date-picker
          v-model="aisDataBase"
          label="AIS Database"
          type="month"
          rules="required|min:7"
        />
      </v-col>
    </v-row>
    <v-row class="mx-auto mb-0 pb-0 mb-n3">
      <v-col cols=12 class="mt-0 pt-0">
        <v-alert
          dense
          outlined
          type="info"
          class="mb-0 py-0 px-1"
        >
          IPCA oficial atualizados até: <b>{{dataUltimoIpcaOficial | formatToMonth}}</b> ({{mesesSemAtualizarIpcaOficial}} meses sem atualizar)<br>
          <template v-if="dataUltimoIpcaNaoOficial">IPCA estimado atualizados até: <b>{{dataUltimoIpcaNaoOficial | formatToMonth}}</b></template>
        </v-alert>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12" id="data-simulacao-laudo">
        <date-picker
          v-model="dataSimulacaoLaudo"
          label="Data de Simulação do Laudo"
          type="month"
          :rules="dataSimulacaoLaudo && dataSimulacaoLaudoValida ? 'required' : 'required|min:7|forcar_erro'"
        />
      </v-col>
    </v-row>
    <v-row class="mx-auto mt-n3" id="data-imobilizacao-simulacao">
       <v-col class="pt-0" xl="5" lg="5" md="5" sm="5" cols="12">
        <date-picker
          v-model="dataImobilizacaoInicio"
          label="Data Imobilização"
          type="date"
          :rules="`required|date_precisa_ser_menor_ou_igual_a:${dataImobilizacaoFim}`"
        />
      </v-col>
      <v-col xl="2" lg="2" md="2" sm="2" cols="12" class="text-center laudo-incremental-vnr-separator-imob-ab" style="min-width:60px !important; padding-top: 32px">
        <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
      </v-col>
      <v-col class="pt-0" xl="5" lg="5" md="5" sm="5" cols="12">
        <date-picker
          v-model="dataImobilizacaoFim"
          label="Data Imobilização"
          type="date"
          :rules="`required|date_precisa_ser_maior_ou_igual_a:${dataImobilizacaoInicio}`"
        />
      </v-col>
    </v-row>
  </validation-observer>
</template>

<script>
import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';
import dayjs from 'dayjs';

export default {
  components: {
    ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
    DatePicker:       () => import("@/components/general/DatePicker.vue")
  },

  created() {
    this.getUltimoIndice();
  },

  data: () => ({
    dataUltimoIpcaOficial: '',
    dataUltimoIpcaNaoOficial: '',
    dataSimulacaoLaudoValida: true
  }),
  
  computed: {
    titulo: {
      get () { return this.$store.state.simulacaoLaudoIncremental.titulo},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'titulo': value})}
    },
    obraMaterialList: {
      get () { return this.$store.state.simulacaoLaudoIncremental.obraMaterialList}
    },
    possuiObra: {
      get () { return this.$store.state.simulacaoLaudoIncremental.possuiObra},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'possuiObra': value})}
    },
    possuiMaterial: {
      get () { return this.$store.state.simulacaoLaudoIncremental.possuiMaterial},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'possuiMaterial': value})}
    },
    depreciaMes: {
      get () { return this.$store.state.simulacaoLaudoIncremental.depreciaMes},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'depreciaMes': value})}
    },
    almoxarifado: {
      get () { return this.$store.state.simulacaoLaudoIncremental.vlrAlmoxarifado},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'vlrAlmoxarifado': value})}
    },
    dataImobilizacaoInicio: {
      get () { return this.$store.state.simulacaoLaudoIncremental.dataImobilizacaoInicio},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'dataImobilizacaoInicio': value})}
    },
    dataImobilizacaoFim: {
      get () { return this.$store.state.simulacaoLaudoIncremental.dataImobilizacaoFim},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'dataImobilizacaoFim': value})}
    },
    aisDataBase: {
      get () { return this.$store.state.simulacaoLaudoIncremental.aisDataBase},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'aisDataBase': value})}
    },
    dataSimulacaoLaudo: {
      get () { return this.$store.state.simulacaoLaudoIncremental.dataSimulacaoLaudo},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'dataSimulacaoLaudo': value})}
    },

    mesesSemAtualizarIpcaOficial() {
      var dataAtual = dayjs();
      var qtdMeses = dataAtual.diff((dayjs(this.dataUltimoIpcaOficial)), 'month');
      return qtdMeses;
    }
  },

  methods: {
    getUltimoIndice() {
      AtualizacaoIndicesService.getUltimoIndiceIpca('IPCA').then((indice) => {
        this.dataUltimoIpcaOficial = indice.indice_oficial ? indice.indice_oficial.DataRegistro : '';
        this.dataUltimoIpcaNaoOficial = indice.indice_estimado ? indice.indice_estimado.DataRegistro : '';
      })
      .catch(() => this.$toast.error('Erro ao buscar ultimo Índice IPCA.', '', { position: 'topRight' }));
    },

    validarDataContempladaIPCA(data) {
      if (!data) return false;

      const dataReferencia = dayjs(data);
      const dataIpca = this.dataUltimoIpcaNaoOficial || this.dataUltimoIpcaOficial;
      if (dataReferencia.isAfter(dataIpca)) {
        this.$toast.error('Erro: A data de simulação do laudo está incorreta, confira o ultimo IPCA .', '', { position: 'topRight' });
        return false;
      }

      return true;
    },

    getOnlyDateIgnoringTimestamp(date) {
      if (date && date.length > 10) { date = date.substr(0, 10)};

      return date;
    }
  },

  watch: {
    dataSimulacaoLaudo(newDate) {
      let dataValida = this.validarDataContempladaIPCA(newDate);
      this.dataSimulacaoLaudoValida = dataValida;
    }
  }
}
</script>